import { Container } from "@mui/material";
import React from "react";
import { Outlet } from "react-router";
import DhAppbar from "../../components/generic/appbar";
import { useInactivityLogout } from "../../core/hooks/use-inactivity-logout";

const AdminPage = () => {
  // Redirect to login after an hour of inactivity (and on return to an already-expired session),
  // so the admin area never lingers in a signed-in-looking but non-functional state.
  useInactivityLogout();

  return (
    <React.Fragment>
      <DhAppbar></DhAppbar>
      <Container maxWidth="xl">
        <Outlet />
      </Container>
    </React.Fragment>
  );
};

export default AdminPage;
